import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const SeoContext = createContext(null);

export function SeoProvider({ children }) {
  const [override, setOverrideState] = useState(null);

  const setOverride = useCallback((value) => {
    setOverrideState(value);
  }, []);

  const value = useMemo(() => ({ override, setOverride }), [override, setOverride]);

  return <SeoContext.Provider value={value}>{children}</SeoContext.Provider>;
}

export function useSeoOverride() {
  const ctx = useContext(SeoContext);
  if (!ctx) throw new Error('useSeoOverride debe usarse dentro de SeoProvider');
  return ctx;
}
